import React, { useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { EquipmentTypes } from "../../types/equipmentTypes";

import { Machine, assign } from "xstate";
import { useMachine } from "@xstate/react";
import Input from "../Input";

const config = {
  id: "equipmentSelect",
  initial: "ready",
  context: {
    value: "",
    otherValue: ""
  },
  states: {
    ready: {
      type: "parallel",
      on: {
        SELECT_TYPE: [
          {
            cond: "didSelectDistinct",
            target: "ready.equipmentType.noError",
            actions: "setEquipmentType"
          },
          {
            cond: "didSelectOther",
            target: "ready.equipmentType.other",
            actions: "setEquipmentType"
          }
        ],
        CHANGE_OTHER_VALUE: {
          actions: "setOtherValue"
        }
      },
      states: {
        equipmentType: {
          initial: "noError",
          states: {
            error: {},
            noError: {},
            other: {
              on: {
                SUBMIT: [{ cond: "isOtherValid", target: "error" }]
              }
            }
          }
        }
      }
    }
  }
};

const machine = Machine(config as any, {
  guards: {
    didSelectOther: (context, event) => {
      return event.value === EquipmentTypes.Other;
    },
    didSelectDistinct: (context, event) => {
      return event.value !== EquipmentTypes.Other;
    },
    isOtherValid: (context, event) => {
      return !!context.otherValue;
    }
  },
  actions: {
    setEquipmentType: assign((context: any, event: any) => ({
      value: event.value
    })),
    setOtherValue: assign((context: any, event: any) => ({
      otherValue: event.value
    }))
  }
});
function EquipmentTypeSelect({
  value,
  otherValue,
  onChange
}: {
  value?: any;
  otherValue?: any;
  onChange: (value) => void;
}) {
  const [current, send] = useMachine(machine);

  return (
    <>
      <FormLabel required component="legend">
        Equipment Type
      </FormLabel>
      <RadioGroup
        aria-label="equipment type"
        name="equipmentType"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const value = (e.target as HTMLInputElement).value;
          send("SELECT_TYPE", { value });
          if (value !== EquipmentTypes.Other) {
            onChange(value);
          } else {
            onChange(null);
          }
        }}
      >
        {Object.keys(EquipmentTypes).map(key => (
          <FormControlLabel
            key={key}
            value={EquipmentTypes[key]}
            control={<Radio />}
            label={EquipmentTypes[key]}
          />
        ))}
      </RadioGroup>
      {current.matches("ready.equipmentType.other") && (
        <Input
          error={current.matches("ready.equipmentType.error")}
          label="Equipment Type"
          name="equipmentType"
          value={otherValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            send("CHANGE_OTHER_VALUE", {
              value: (e.target as HTMLInputElement).value
            });
            onChange((e.target as HTMLInputElement).value);
          }}
          style={{ width: "100%" }}
        />
      )}
    </>
  );
}

export default EquipmentTypeSelect;
